import axios from 'smg/axios';
import * as models from 'smg/customer-api/models';
import { Session } from 'smg/customer-api/session';
import * as shippingoptions from 'smg/customer-api/shippingoptions';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { AccountReady } from '../account-session';
import { PageLoader } from '../account';
import * as address from '../address';
import { CheckPOBoxAddress, PromptNew } from '../shippingoptions';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const parent = document.querySelector('#shippingAdressesContainer') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');
    const cardTemplate = document.querySelector('#cards') as HTMLTemplateElement;

    let user: models.User;

    const pl: PageLoader<models.HyejooShippingOption> = new PageLoader<models.HyejooShippingOption>({
        afterLoad: state => {
            if (state === 'failed') {
                return;
            }
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        init: async () => {
            user = await Session().then(s => s.user);
            addNewButton.forEach(el => {
                el.addEventListener('click', async () => {
                    await PromptNew(user).then(() => {
                        pl.load();
                    });
                });
            });
        },
        parent: document.querySelector('#shippingAdressesContainer') as HTMLElement,
        get: () => axios.get('/shipping-options', {
            params: {
                'sort': pl.sort(),
                'max': pl.currentPageSize(),
                'data': 'id,label,address',
                'p': pl.currentPage(),
                'q': pl.search(),
            },
        }).then(resp => {
            const data = models.ShippingOptionsHyejooResponse.fromJSON(resp.data);
            return { rows: data.shippingOptions, nextPage: data.nextPage };
        }),
        draw: async shippingOption => {
            const card = template.Clone(cardTemplate).firstElementChild as HTMLElement;
            const shippingAddress = shippingOption.address;
            if (!shippingAddress) {
                return card;
            }
            const addressEl = address.Draw(shippingAddress);
            const addressParent = card.querySelector<HTMLElement>('.address');

            addressParent?.appendChild(addressEl);

            // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
            if (!phone.IsValid(shippingAddress.phoneNumber?.phone ?? '')) {
                addressParent?.appendChild(phone.InvalidPhoneNote());
            }

            // Grab user details
            const user = await Session().then(s => s.user);
            const editBtn = card.querySelector('.edit-btn') as HTMLButtonElement;
            const deleteBtn = card.querySelector('.delete-btn') as HTMLButtonElement;

            editBtn?.addEventListener('click', () => {
                void PromptNew(user, shippingOption).then(() => {
                    pl.load();
                });
            });

            deleteBtn?.addEventListener('click', () => {
                void shippingoptions.DeleteShippingOption(shippingOption.id).then(() => {
                    card.parentElement?.removeChild(card);
                    toast.Undo('Removed shipping option.', async () => {
                        await shippingoptions.RestoreShippingOption(shippingOption.id);
                        pl.load();
                    });
                    pl.load();
                });
            });
            void CheckPOBoxAddress(shippingAddress.countryID, shippingAddress.stateID || 0, shippingAddress.addressLine1 || '', addressParent as HTMLElement);
            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.load();
}
